// extracted by mini-css-extract-plugin
export default {"iconSection":"HeaderIcons_iconSection__NabXH","iconSvg":"HeaderIcons_iconSvg__2jLo1"};